import { SidebarMenuItem } from '../../Types/Layout.type';

export const menuList: SidebarMenuItem[] = [
   {
      title: 'Sociedad',
      lanClass: 'lan-2',
      items: [
         {
            icon: 'Home-dashboard',
            path: `${process.env.PUBLIC_URL}/dashboard/panel`,
            title: 'Banco',
            type: 'link',
         },
         {
            title: 'Solicitudes',
            id: 1,
            icon: 'Edit',
            type: 'sub',
            active: false,
            children: [
               {
                  path: `${process.env.PUBLIC_URL}/dashboard/loanRequest`,
                  title: 'Préstamos',
                  type: 'link',
               },
               {
                  path: `${process.env.PUBLIC_URL}/dashboard/withdrawal`,
                  title: 'Retiros',
                  type: 'link',
               },
            ],
         },
         {
            icon: 'Chart',
            path: `${process.env.PUBLIC_URL}/dashboard/investment`,
            title: 'Inversion',
            type: 'link',
         },
         {
            icon: 'Activity',
            path: `${process.env.PUBLIC_URL}/dashboard/interests`,
            title: 'Intereses',
            type: 'link',
         },
         {
            icon: 'Wallet',
            path: `${process.env.PUBLIC_URL}/dashboard/debt`,
            title: 'Deuda',
            type: 'link',
         },
         {
            icon: 'Contacts',
            path: `${process.env.PUBLIC_URL}/dashboard/community`,
            title: 'Comunidad',
            type: 'link',
         },
      ],
   },
   {
      title: 'Empresarial',
      items: [
         {
            id: 6,
            title: 'Presupuesto',
            icon: 'Pie',
            type: 'sub',
            active: false,
            children: [
               {
                  title: 'Resumen',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/dashboard/budget`,
               },
               {
                  title: 'Ingresos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/dashboard/income`,
               },
               {
                  title: 'Egresos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/dashboard/expenses`,
               },
               {
                  title: 'Activos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/dashboard/assets`,
               },
               {
                  title: 'Pasivos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/dashboard/liabilities`,
               },
            ],
         },
      ],
   },
   {
      title: 'Configuration',
      lanClass: 'lan-2',
      items: [
         {
            id: 7,
            title: 'Usuario',
            icon: 'Profile',
            type: 'sub',
            active: false,
            children: [
               // {
               //    title: 'Perfil',
               //    type: 'link',
               //    path: `${process.env.PUBLIC_URL}/dashboard/account/user_profile`,
               // },
               {
                  title: 'Perfil',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/dashboard/account/edit_profile`,
               },
            ],
         },
         {
            id: 8,
            title: 'Accesibilidad',
            icon: 'Unlock',
            type: 'sub',
            active: false,
            role: 'admin',
            children: [
               {
                  title: 'Roles',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/roles`,
               },
               {
                  title: 'Permisos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/permissions`,
               },
            ],
         },
         {
            id: 9,
            title: 'Maestros',
            icon: 'Filter',
            type: 'sub',
            active: false,
            role: 'admin',
            children: [
               {
                  title: 'Usuarios',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/master_data/users`,
               },
               {
                  title: 'Bancos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/master_data/banks`,
               },
               {
                  title: 'Tipo de Transacciones',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/master_data/transactions`,
               },
            ],
         },
         {
            id: 10,
            title: 'Administración',
            icon: 'Work',
            type: 'sub',
            active: false,
            role: 'admin',
            children: [
               {
                  title: 'Intereses',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/interests`,
               },
               {
                  title: 'Pagos',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/payments`,
               },
               {
                  title: 'Inversiones',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/investments`,
               },
               {
                  title: 'Transacciones',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/transactions`,
               },
               {
                  title: 'Asistencia Financiera',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/financial_assistance`,
               },
               {
                  title: 'Rondas de Inversion',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/investment_rounds`,
               },
               {
                  title: 'Solicitudes de Préstamo',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/loan_requests`,
               },
               {
                  title: 'Desembolsos crediticios',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/credit_portfolio`,
               },
               {
                  title: 'Amortizaciones',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/amortizations`,
               },
               {
                  title: 'Estados de cuenta',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/financial_statements`,
               },
               {
                  title: 'Solicitudes de Retiros',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/administration/withdrawal_requests`,
               },
            ],
         },
         {
            id: 11,
            title: 'Configuración',
            icon: 'Setting',
            type: 'sub',
            active: false,
            role: 'admin',
            children: [
               {
                  title: 'Sistema',
                  type: 'link',
                  path: `${process.env.PUBLIC_URL}/configuration/settings/system`,
               },
            ],
         },
      ],
   },
];
